import type { FC } from 'react';
import { Suspense, lazy } from 'react';
import WidgetConfigPopover from '@wix/da-gruser-shared/pkg/components/WidgetBox/lego/WidgetConfigPopover';

const AboutMeConfigModal = lazy(
  () => import(/* webpackChunkName: "owner" */ '../../AboutMeConfigModal')
);

type Props = any;

const AboutMeConfigModalLazy: FC<Props> = props => {
  return (
    <Suspense fallback={<WidgetConfigPopover isLoading onClose={() => null} />}>
      <AboutMeConfigModal {...props} />
    </Suspense>
  );
};
AboutMeConfigModalLazy.displayName = 'AboutMeConfigModalLazy';

export default AboutMeConfigModalLazy;
